var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
var Visible = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M19.918,12.298 L20,12.5 L19.918,12.701 C19.813,12.959 17.293,19 11.5,19 C5.707,19 3.187,12.959 3.082,12.701 L3,12.5 L3.082,12.298 C3.187,12.041 5.707,6 11.5,6 C17.293,6 19.813,12.041 19.918,12.298 Z M4.089,12.499 C4.567,13.51 6.932,17.964 11.5,17.964 C16.08,17.964 18.435,13.512 18.911,12.5 C18.433,11.49 16.068,7.036 11.5,7.036 C6.92,7.036 4.565,11.488 4.089,12.499 Z M11.5,15.75 C9.70507456,15.75 8.25,14.2949254 8.25,12.5 C8.25,10.7050746 9.70507456,9.25 11.5,9.25 C13.2949254,9.25 14.75,10.7050746 14.75,12.5 C14.75,14.2949254 13.2949254,15.75 11.5,15.75 Z M11.5,14.75 C12.7426407,14.75 13.75,13.7426407 13.75,12.5 C13.75,11.2573593 12.7426407,10.25 11.5,10.25 C10.2573593,10.25 9.25,11.2573593 9.25,12.5 C9.25,13.7426407 10.2573593,14.75 11.5,14.75 Z" })));
};
Visible.displayName = 'Visible';
export default Visible;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Visible.js.map